// extracted by mini-css-extract-plugin
export default {"ingredientsSection":"tG-z","listContainer":"uG-z","ingredients":"vG-z","description":"wG-z"};